interface Item {
  name: string
  url: string
}

interface Category {
  category: string
  items: Item[]
}

const items: Category[] = [
  {
    category: 'Public Access',
    items: [
      { name: 'Meraki', url: 'https://account.meraki.com/login' },
      { name: 'Zabbix', url: 'https://monitoring.mad.co.id/' },
      { name: 'NA-Prod-SDWAN', url: 'https://na.int.is-global.com/' },
      { name: 'LibreNMS SDWAN- Taiwan', url: 'https://sdwan-nms.int.is-global.com/' },
      { name: 'Grafana-Production', url: 'https://grafana.is-global.com/' },
      { name: 'Zoho People', url: 'https://people.zoho.com/isglobalservices' },
      { name: '3CX - Demo (Cloudwego02)', url: 'https://cloudwego02.3cx.asia:5001/#/people' },
      { name: '3CX - Production', url: 'https://isgsinternal.3cx.asia:5003/#/people' },
      { name: 'Password Management', url: 'https://vault.is-global.com' },
      { name: 'IS Helpdesk', url: 'https://support.is-global.com' },
      { name: 'Respond.IO', url: 'https://app.respond.io' },
      { name: 'CAST - Demo', url: 'https://demo.cast.cloudwego.net/' },
      { name: 'CAST - Production', url: 'https://cast.cloudwego.net/' },
      { name: 'CMS MAD Hotelier', url: 'https://staging.madhotelier.mad.co.id/portal-tenants/' },
      { name: 'CMS Dunia KPH', url: 'https://cms.duniakph.com/' },
      { name: 'CMS QR Ads', url: 'https://qrads.is-global.com/' },
      { name: 'Certificate Monitoring', url: 'https://iam.redsift.cloud/login' },
      { name: 'Vonage Key Management', url: 'https://vonage-km.is-global.com' },
      { name: 'Knowledge Management', url: 'https://km.is-global.com' },
      { name: 'ERP Next', url: 'https://erp.is-global.com' },
      { name: 'AI Demo', url: 'https://ai-demo.is-global.com' },
    ],
  },
  {
    category: 'Local Access',
    items: [
      { name: 'NNM', url: 'https://nnm-lab.is-global.local/nnm' },
      { name: 'NA', url: 'https://na-lab.is-global.local/nnm' },
      { name: 'OBM', url: 'https://obm-lab.is-global.local/nnm' },
      { name: 'NOM', url: 'https://nom-coso.is-global.local:9443/bvd/' },
      { name: 'OO', url: 'https://oo-lab.is-global.local:8443/oo' },
      { name: 'OO-SSX', url: 'https://oo-lab.is-global.local:8446/oo-ssx/login' },
      { name: 'Jenkins', url: 'https://jenkin.is-global.local/' },
      { name: 'Ipam', url: 'https://ipam.is-global.local/' },
    ],
  },
  {
    category: 'Principal Partner Portal',
    items: [
      {
        name: 'AWS Partner Central',
        url: 'https://partnercentral.awspartner.com/partnercentral2/s/login',
      },
      {
        name: 'Fortinet',
        url: 'https://partnerportal.fortinet.com/English/',
      },
      {
        name: 'Cisco',
        url: 'https://id.cisco.com/app/ciscoid_aemcloudprodsaml_1/exk14lk1xf6SKDANc5d7/sso/saml',
      },
      {
        name: 'OpenText',
        url: 'https://login.microfocus.com/nidp/saml2/sso?id=283&sid=0&option=credential&sid=0',
      },
    ],
  },
  // Add more categories and items as needed
]

export default items
